module.exports = __webpack_public_path__ + "img/thumb-laab-kai-thaise-kipsalade.8ba89593.jpeg";